import { render, staticRenderFns } from "./syncPull.vue?vue&type=template&id=74d1bf9c&scoped=true"
import script from "./syncPull.vue?vue&type=script&lang=js"
export * from "./syncPull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d1bf9c",
  null
  
)

export default component.exports